import * as helpers from './helpers'
import { defaultExtendedFilters, defaultFilters } from 'Global/Helpers/rugHelpers'

import {
  APPLY_EXTENDED_FILTERS,
  APPLY_FILTERS,
  RESET_EXTENDED_FILTERS,
  RESET_FILTERS,
  SEARCH_SAVE_FULFILLED,
  SEARCH_SAVE_PENDING,
  SEARCH_SAVE_REJECTED,
  SEARCH_SAVE_RESET,
  SEARCH_FORM_TOGGLE,
} from './actionTypes'

export const initialState = {
  dones: { saveSearch: false },
  errors: { saveSearch: false },
  extendedFilters: defaultExtendedFilters,
  filters: defaultFilters,
  pendings: { saveSearch: false },
  searchForm: true,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case APPLY_EXTENDED_FILTERS:
      return {
        ...state,
        extendedFilters: {
          ...state.extendedFilters,
          ...payload,
          active: !helpers.compareExtendedFilters(payload, initialState.extendedFilters),
        },
        page: 1,
      }

    case APPLY_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
        page: 1,
      }

    case RESET_EXTENDED_FILTERS:
      return {
        ...state,
        extendedFilters: initialState.extendedFilters,
      }

    case RESET_FILTERS:
      return {
        ...state,
        extendedFilters: initialState.extendedFilters,
        filters: initialState.filters,
      }

    case SEARCH_SAVE_FULFILLED:
      return {
        ...state,
        dones: {
          ...state.dones,
          saveSearch: true,
        },
        errors: {
          ...state.errors,
          saveSearch: false,
        },
        pendings: {
          ...state.pendings,
          saveSearch: false,
        },
      }

    case SEARCH_SAVE_PENDING:
      return {
        ...state,
        dones: {
          ...state.dones,
          saveSearch: false,
        },
        errors: {
          ...state.errors,
          saveSearch: false,
        },
        pendings: {
          ...state.pendings,
          saveSearch: true,
        },
      }

    case SEARCH_SAVE_REJECTED:
      return {
        ...state,
        dones: {
          ...state.dones,
          saveSearch: false,
        },
        errors: {
          ...state.errors,
          saveSearch: true,
        },
        pendings: {
          ...state.pendings,
          saveSearch: false,
        },
      }

    case SEARCH_SAVE_RESET:
      return {
        ...state,
        dones: {
          ...state.dones,
          saveSearch: false,
        },
      }

    case SEARCH_FORM_TOGGLE:
      return {
        ...state,
        searchForm: !state.searchForm,
      }

    default:
      return state
  }
}

export default reducer
